import React from 'react';

// One labelled row on the profile. The label never moves between view and edit
// mode — only what sits under it changes — so the page doesn't reflow when the
// user starts editing.
//
// `locked` marks a field the viewer may read but not change. It only shows its
// padlock while the page is in edit mode, where the absence of an input would
// otherwise look like a bug.
export default function ProfileField({
  label,
  locked = false,
  showLock = false,
  hint,
  error,
  full = false,
  children,
}) {
  return (
    <div className={`me-field${full ? ' me-field--full' : ''}`}>
      <div className="me-field__label">
        <span>{label}</span>
        {locked && showLock ? (
          <i className="bi bi-lock-fill" title="Read only" aria-label="Read only" />
        ) : null}
      </div>

      {children}

      {hint ? <div className="me-field__hint">{hint}</div> : null}
      {error ? <div className="me-field__error">{error}</div> : null}
    </div>
  );
}

// A stored value in view mode. An unset value reads as an em dash rather than
// an empty row, so a sparse card still has rhythm.
export function ProfileValue({ value, strong = false, mono = false }) {
  const text = value == null ? '' : String(value);
  const isEmpty = text.trim().length === 0;

  const classes = ['me-field__value'];
  if (strong && !isEmpty) classes.push('me-field__value--strong');
  if (mono && !isEmpty) classes.push('bdc-num');
  if (isEmpty) classes.push('me-field__value--empty');

  return <div className={classes.join(' ')}>{isEmpty ? '—' : text}</div>;
}
